import { GridOptions } from "ag-grid-community";

export const ANIMATION_START_TIMEOUT = 25;
export const ROW_ID_KEY = "id";
export const BASE_TOOLTIP_COMPONENT_ID = "BaseTooltip";
export const STANDARD_TOOLTIP_COMPONENT_ID = "StandardTooltip";
export const TABLE_LOADED_CLASS = "ag-theme-data-loaded";
export const TABLE_LOADING_CLASS = "ag-theme-data-loading";
export const TOOLTIP_ANIMATION_CLASS = "animate";
export const TOOLTIP_ANIMATION_DURATION = 0.2;
export const CHANGE_DATA_TIMEOUT = 0.3;

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  groupHeaderHeight: 32,
  headerHeight: 32,
  rowHeight: 32,
  defaultColDef: {
    
  }
};
